import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand",
  "use": "expand-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"expand\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.3 6.7L3 9V3h6L6.7 5.3l2.89 2.87-1.42 1.42L5.3 6.7zm12-1.4L15 3h6v6l-2.3-2.3-2.87 2.89-1.42-1.42L17.3 5.3zM9 21l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm9.7-3.7L21 15v6h-6l2.3-2.3-2.89-2.87 1.42-1.42 2.87 2.89z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol